/**
  new IntervalMap<T>(
below: T,
{
    0: ..,
    1: ..,
    3: ..,
    4: ..,
    8: ..,
},
above: T
)
**/

export default class IntervalMap {
    constructor(below, map, above) {
        this.below = below
        this.map = map
        this.above = above
        let bounds = Object.keys(map) // .sort((a,b) => Number(a) < Number(b))
        this.min = bounds[0]
        this.max = bounds[bounds.length - 1]
    }

    get (n) {
        if (n < this.min) { return this.below }
        else if (n > this.max) { return this.above }
        else if (n in this.map) { return this.map[n] }
        else return this.below
    }

    toString () {
        return `<IntervalMap ${this.min} ${this.max}>`
    }
}

/** test

var i = new IntervalMap(
    { nom: "vide", prix: 5 },
    {
        1: { nom: "modeste", prix: 5 },
        2: { nom: "titan", prix: 7 },
        3: { nom: "imperial", prix: 9 },
    },
    { nom: "ultra", prix: 12 },
)

**/
